import produce from 'immer';
import ACTIONS from '../../actions';
var initialState = {};
export var selectionReducer = function selectionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ACTIONS.GRID_SELECTION_SET:
      {
        var _action$payload = action.payload,
            id = _action$payload.id,
            selection = _action$payload.selection;
        var nextState = produce(state, function (draft) {
          draft[id] = selection;
        });
        return nextState;
      }

    default:
      return state;
  }
};
export default selectionReducer;